import React from "react"
import Codechef from "./Codechef.js"
// import Codeforces from "./Codeforces.js"
import Tags from "./tags.js"
import {
  FaTwitter as Twitter,
  FaGithub as Github,
  FaEnvelope as Mail,
  FaLinkedin as LinkedIn,
  FaDownload as DownloadIcon
} from "react-icons/fa"

let skills = ["Python", "JavaScript", "C++", "HTML/CSS", "Java", "Bootstrap", "React.js", "Flask", "Node.js", "MongoDB", "PostgreSQL", "Firebase", "Git", "*nix Shell", "Docker", "AWS"]

let resumeURL = "https://drive.google.com/file/d/1CPSeh4XMcLF7Mlc8wh6esq48_1yqYUFa/view?usp=drive_link"

let randomColors = ["#27fb6b", "#0adbcd", "#ff2e63", "#f1e05a"]

export default function info() {
  return (
    <div className="container">
      <div className="my-5"></div>
      <div className="display-4" style={{ color: "#FF8A00" }}>
        <span style={{ color: "white" }}>Hello, I'm</span> <br />
        Kaustubh Damania.
      </div>
      <div className="h1 code mt-4 mb-3">about_me {"{"}</div>
      <div className="text-muted mx-5 my-4 h3 text-justify info">
        A Passionate Full Stack Developer, Competitive Programmer, Machine Learning Enthusiast.
        <br />
      </div>
      <div className="text-muted mx-5 my-4 h4 text-justify info">
        I am a Software Development Engineer - II working at Amazon in the Consumer Payments and Agent Chat space in Customer Service organization.
        Over the past few years, I've worked on a variety of stuff like running my college's <a className="url" href="https://csikjsce.org/">largest programming club</a>, hackathons, internships, competitive programming, research, etc. In my free time, you'll find me watching/playing football, playing games like Valorant, CS:GO or just binging on Netflix.
        <br /><br />
        I am looking for full time job opportunities or freelance projects as a Software Developer.
        <br />
        <div className="download-link-parent">
          <a className="download-btn tag" target="_blank" rel="noopener noreferrer" href={resumeURL}>Download Resume <DownloadIcon /></a>
        </div>
      </div>

      <div className="h1 code mt-2 mb-3">{"}"}</div>

      <div className="h1 code mt-4 mb-3">skills {"{"}</div>
      <div className="text-muted h4 mx-5 my-4">
        <Tags content={skills} randomColors={randomColors} />
      </div>
      <div className="h1 code mt-2 mb-3">{"}"}</div>

      <div className="h1 code mt-4 mb-3">contact_me {"{"}</div>
      <div className="h1 mt-5 text-center">
        <div className="h4">
          You can reach out to me on the following platforms:<br />
        </div>
        <a className="mr-5 icon" href="https://linkedin.com/in/kaustubh-damania">
          <LinkedIn />
        </a>
        <a className="mr-5 icon" href="https://github.com/KaustubhDamania">
          <Github />
        </a>
        <a className="mr-5 icon" href="mailto:kaustubh.damania@gmail.com">
          <Mail />
        </a>
        <a className="mr-5 icon" href="https://twitter.com/DamaniaKaustubh">
          <Twitter />
        </a>
        <a className="mr-5 icon" href="https://www.codechef.com/users/kpdamania">
          <Codechef />
        </a>
        {/* <a className="mr-5 icon" href="https://www.codeforces.com/profile/kaustubh_damania"> */}
        {/* <Codeforces /> */}
        {/* </a> */}
      </div>
      <div className="h1 code mt-2 mb-3">{"}"}</div>
    </div>
  )
}
